import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiUrl, formatApiError } from "../../lib/api";
import AdminShell from "../../components/AdminShell";
import { Button, Card } from "../../components/ui-kit";
import { ClockClockwise } from "@phosphor-icons/react";

const ACTION_LABEL = {
  "driver.approve": "Approuver chauffeur",
  "driver.reject": "Bloquer chauffeur",
  "pricing.update": "Modifier tarif",
  "incident.resolve": "Résoudre incident",
  "document.approve": "Approuver document",
  "document.reject": "Refuser document",
};

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/admin/audit"); setLogs(data); }
      catch (e) { toast.error(formatApiError(e)); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <AdminShell title="Audit">
      <div className="admin-page-header">
        <div className="min-w-0">
          <h1 className="responsive-title flex items-center gap-3 font-heading text-3xl font-black tracking-tighter sm:text-4xl" data-testid="audit-title">
            <ClockClockwise weight="fill" /> Journal d'audit
          </h1>
          <p className="text-sm text-muted-foreground">Historique complet des actions administrateur.</p>
        </div>
        <div className="admin-actions">
          <a href={apiUrl("/admin/audit/export.csv")} target="_blank" rel="noreferrer">
            <Button>CSV</Button>
          </a>
          <a href={apiUrl("/admin/audit/export.pdf")} target="_blank" rel="noreferrer">
            <Button variant="outline">PDF</Button>
          </a>
        </div>
      </div>
      <div className="mt-6 space-y-2">
        {loading && <div className="text-sm font-bold uppercase tracking-widest">Chargement…</div>}
        {logs.map(l => (
          <Card key={l.id} className="p-3" data-testid={`audit-${l.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="font-heading text-sm font-black text-primary">
                  {ACTION_LABEL[l.action] || l.action}
                </div>
                <div className="font-mono text-[10px] text-muted-foreground">
                  par {l.actor_email} · cible {l.target_type || "—"} {l.target_id ? `#${String(l.target_id).slice(0, 8)}` : ""}
                </div>
                {l.meta && Object.keys(l.meta).length > 0 && (
                  <pre className="mt-1 rounded bg-white/5 p-2 text-[10px] font-mono text-muted-foreground overflow-x-auto">{JSON.stringify(l.meta)}</pre>
                )}
              </div>
              <div className="text-[10px] font-mono text-muted-foreground whitespace-nowrap">
                {new Date(l.at).toLocaleString("fr-FR")}
              </div>
            </div>
          </Card>
        ))}
        {!loading && logs.length === 0 && (
          <Card className="p-8 text-center text-sm font-bold uppercase tracking-widest text-muted-foreground" data-testid="audit-empty">
            Aucune action enregistrée
          </Card>
        )}
      </div>
    </AdminShell>
  );
}
